import { useCallback } from 'react'
import useFlow from '../../../state/use-flow'
import Step from '../../step/step'

export default function DedicationStep() {
  const flow = useFlow()

  const goNext = useCallback(() => {
    if (flow.nextStep) {
      flow.goToStep(flow.nextStep.name)
    }
  }, [])

  return (
    <Step.Root header={{ headline: 'Dedication' }}>
      <Step.Content>Content goes here</Step.Content>
      <Step.ActionButton onClick={goNext}>Go Next</Step.ActionButton>
    </Step.Root>
  )
}
